import {createSelector} from 'reselect';
import {getTravelerFeatures, getTripData} from './store';
import {getIsMobile} from './system';
import {getIsColdStartUser, getLocationIsWithinRecentGeoSearch} from '../utils/travelerSegments';
import {getPreferredLocation} from './listing';

const getTravelerSegments = createSelector(
    [getTravelerFeatures, getTripData, getPreferredLocation],
    (travelerFeatures, tripData, preferredLocation) => {
        const {
            arrivedFromEmail,
            arrivedFromExternalSite,
            arrivedFromFacebook,
            cookies,
            hasRecentGeoSearch,
            isLoggedIn
        } = travelerFeatures;
        const {arrivedWithoutDates} = tripData;

        return {
            arrivedFromEmail,
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            hasRecentGeoSearch,
            isLoggedIn,
            coldStartUser: getIsColdStartUser(travelerFeatures),
            locationIsWithinRecentGeoSearch: getLocationIsWithinRecentGeoSearch(
                preferredLocation,
                cookies
            )
        };
    }
);
const getTravelerSegmentFeatures = createSelector(
    [getTravelerSegments, getTripData, getIsMobile],
    (travelerSegments, tripData, isMobile) => {
        const {
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            coldStartUser,
            hasRecentGeoSearch,
            locationIsWithinRecentGeoSearch
        } = travelerSegments;
        const {arriveDateText, departDateText} = tripData;
        const hasDates = arriveDateText && departDateText;

        return {
            showLastSearchedLocation:
                !arrivedFromExternalSite && hasRecentGeoSearch && locationIsWithinRecentGeoSearch,
            showTopRecoCarousel: coldStartUser,
            showMidpageRecoCarousel: coldStartUser,
            usePrimarySearchBoxSubmit: coldStartUser,
            hideSearchBoxGuestsMobile: coldStartUser,
            showBackToSerp: coldStartUser,
            useCheckAvailabilityButton: coldStartUser && arrivedWithoutDates,
            redirectToPinnedSerpOnDateEntry:
                coldStartUser && arrivedWithoutDates && !arrivedFromFacebook && !hasDates,
            showExpandedSearchForm: coldStartUser && isMobile
        };
    }
);

export {getTravelerSegments, getTravelerSegmentFeatures};
